'use client';

import { FC } from 'react';
import { useRouter } from 'next/navigation';
import { ProfileSubtitle } from '@/layouts/Base/components/ProfileSubititle';
import { LoggedInUserDisplayWrapper } from './LoggedInUserDisplayWrapper';

export const GuestUserDisplay: FC = () => {
  const { push } = useRouter();

  const handleUserDisplayClick = () => {
    push('/auth/complete-register');
  };

  return (
    <LoggedInUserDisplayWrapper
      id="home_click_profile"
      onClick={handleUserDisplayClick}
    >
      <ProfileSubtitle />
    </LoggedInUserDisplayWrapper>
  );
};
